(function () {
  'use strict';

  var KEY = 'bqc_wishlist_v1';
  var EVENT = 'bqc:wishlist:change';
  var MAX_ITEMS = 200;

  var canStore = (function () {
    try {
      var probe = '__bqc_wl__';
      window.localStorage.setItem(probe, '1');
      window.localStorage.removeItem(probe);
      return true;
    } catch (e) {
      return false;
    }
  })();

  var memoryStore = [];

  function read() {
    if (!canStore) return memoryStore.slice();

    var raw;
    try {
      raw = window.localStorage.getItem(KEY);
    } catch (e) {
      return [];
    }
    if (!raw) return [];

    var parsed;
    try {
      parsed = JSON.parse(raw);
    } catch (e) {
      return [];
    }
    if (!Array.isArray(parsed)) return [];

    return parsed
      .filter(function (item) {
        return item && item.id && item.handle;
      })
      .map(function (item) {
        return {
          id: String(item.id),
          handle: String(item.handle),
          at: Number(item.at) || 0
        };
      });
  }

  function write(items) {
    var capped = items.slice(0, MAX_ITEMS);

    if (canStore) {
      try {
        window.localStorage.setItem(KEY, JSON.stringify(capped));
      } catch (e) {
        memoryStore = capped;
      }
    } else {
      memoryStore = capped;
    }

    emit(capped);
    return capped;
  }

  function emit(items) {
    var detail = { items: items, count: items.length };
    var event;

    try {
      event = new CustomEvent(EVENT, { detail: detail });
    } catch (e) {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(EVENT, true, true, detail);
    }

    document.dispatchEvent(event);
  }

  function indexOf(items, id) {
    id = String(id);
    for (var i = 0; i < items.length; i++) {
      if (items[i].id === id) return i;
    }
    return -1;
  }

  var API = {
    get: function () {
      return read().sort(function (a, b) {
        return b.at - a.at;
      });
    },

    count: function () {
      return read().length;
    },

    has: function (id) {
      return indexOf(read(), id) !== -1;
    },

    add: function (id, handle) {
      if (!id || !handle) return false;

      var items = read();
      if (indexOf(items, id) !== -1) return false;

      items.unshift({ id: String(id), handle: String(handle), at: Date.now() });
      write(items);
      return true;
    },

    remove: function (id) {
      var items = read();
      var at = indexOf(items, id);
      if (at === -1) return false;

      items.splice(at, 1);
      write(items);
      return true;
    },

    toggle: function (id, handle) {
      if (API.has(id)) {
        API.remove(id);
        return false;
      }
      API.add(id, handle);
      return true;
    },

    clear: function () {
      write([]);
    },

    toast: showToast
  };

  function syncButtons(items) {
    var active = {};
    items.forEach(function (item) {
      active[item.id] = true;
    });

    var buttons = document.querySelectorAll('[data-bqc-wl]');
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var on = active[String(button.getAttribute('data-wl-id'))] === true;
      var label = on ? 'Remove from wishlist' : 'Add to wishlist';

      button.classList.toggle('is-liked', on);
      button.classList.toggle('is-active', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
    }
  }

  function syncBadges(items) {
    var count = items.length;
    var badges = document.querySelectorAll('[data-bqc-wishlist-count]');

    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count > 99 ? '99+' : String(count);
      if (count > 0) {
        badges[i].removeAttribute('hidden');
      } else {
        badges[i].setAttribute('hidden', 'hidden');
      }
    }
  }

  function refresh() {
    var items = read();
    syncButtons(items);
    syncBadges(items);
  }


  var toastEl = null;
  var toastTimer = null;

  function showToast(message) {
    if (!message) return;

    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.style.cssText = [
        'position:fixed',
        'left:50%',
        'bottom:28px',
        'transform:translate(-50%,14px)',
        'z-index:99999',
        'max-width:calc(100vw - 32px)',
        'padding:11px 18px',
        'border-radius:999px',
        'background:#111',
        'color:#fff',
        'font-family:Montserrat,Arial,Helvetica,sans-serif',
        'font-size:12px',
        'font-weight:600',
        'letter-spacing:.02em',
        'text-align:center',
        'box-shadow:0 8px 24px rgba(0,0,0,.22)',
        'opacity:0',
        'pointer-events:none',
        'transition:opacity .22s ease,transform .22s ease'
      ].join(';');
      document.body.appendChild(toastEl);
    }

    toastEl.textContent = message;

    void toastEl.offsetWidth;
    toastEl.style.opacity = '1';
    toastEl.style.transform = 'translate(-50%,0)';

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.style.opacity = '0';
      toastEl.style.transform = 'translate(-50%,14px)';
    }, 2200);
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var button = target.closest('[data-bqc-wl]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      var id = button.getAttribute('data-wl-id');
      var handle = button.getAttribute('data-wl-handle');
      if (!id || !handle) return;

      var added = API.toggle(id, handle);
      var name = button.getAttribute('data-wl-title');

      showToast(
        added
          ? (name ? name + ' added to wishlist' : 'Added to wishlist')
          : (name ? name + ' removed from wishlist' : 'Removed from wishlist')
      );
    },
    true
  );


  document.addEventListener(EVENT, function (event) {
    syncButtons(event.detail.items);
    syncBadges(event.detail.items);
  });

  /* Another tab changed the wishlist. Re-emit rather than only re-syncing, so
     listeners such as the wishlist page can rebuild themselves. */
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) emit(read());
  });

  /* Theme editor re-renders a section. */
  document.addEventListener('shopify:section:load', refresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  window.BQCWishlist = API;
})();
